/** @jsxImportSource @emotion/react */
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { accessAPI, TablaFiltrable } from "../../shared";

import { Accordion, AccordionTab } from "primereact/accordion";
import { Column } from "primereact/column";
import { Skeleton } from "primereact/skeleton";
import { Tag } from "primereact/tag";

const FILTROS = [
  { campo: "_tipoHallazgo", label: "Tipo de hallazgo", labelPlural: "tipos de hallazgo" }
];
const SEARCH_FIELDS = ["_clienteText", "_procesoText", "_tipoHallazgo", "_colaboradorText"];

// Mismo patrón que los días en el paso de "Actividades sin decisor": Tag
// con color según antigüedad.
function diasBody(h) {
  const d = h._dias;
  const severity = d <= 1 ? "success" : d <= 3 ? "warning" : "danger";
  return <Tag severity={severity} value={`${d} ${d === 1 ? "día" : "días"}`} />;
}

export default function HallazgosPendientes({ toast }) {
  const [hallazgos, setHallazgos] = useState();
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    accessAPI(
      "GET",
      "admin/hallazgo/pendientes",
      null,
      (respuesta) => {
        setHallazgos(respuesta);
        setLoading(false);
      },
      (respuesta) => {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al cargar hallazgos",
          sticky: true
        });
        setLoading(false);
      }
    );
  }, [toast]);

  if (!loading && (!hallazgos || hallazgos.length === 0)) {
    return null;
  }

  if (loading) {
    return (
      <div css={{ marginTop: "1em" }}>
        <Skeleton width="100%" height="3.5rem" borderRadius="6px" />
      </div>
    );
  }

  const datos = hallazgos.map((h) => {
    const cliente = h.actividad.proceso.cliente;
    const clienteText =
      cliente?.nombrefantasia && cliente.nombrefantasia !== cliente.razonsocial
        ? `${cliente.razonsocial} (${cliente.nombrefantasia})`
        : cliente?.razonsocial || "-";
    const colaborador = h.auditorCreador
      ? `${h.auditorCreador.nombre} ${h.auditorCreador.apellido}`
      : "-";

    return {
      ...h,
      _clienteText: clienteText,
      _procesoText: `${h.actividad.proceso.nombre} - ${h.actividad.proceso.nombrefantasia}`,
      _tipoHallazgo: h.hallazgoTipo?.nombre || "-",
      _colaboradorText: colaborador,
      _dias: Math.floor((Date.now() - new Date(h.fechaCreacion).getTime()) / 86400000)
    };
  });

  return (
    <Accordion
      activeIndex={null}
      css={{
        marginTop: "1em",
        "& .p-accordion-header-link": { color: "black" },
        "& .p-toggleable-content": { transition: "max-height 0.15s ease" }
      }}
    >
      <AccordionTab header={`Hallazgos pendientes de cierre (${hallazgos.length})`}>
        <TablaFiltrable
          value={datos}
          filtros={FILTROS}
          searchFields={SEARCH_FIELDS}
          busquedaAlFinal
          anchoBusqueda="33%"
          nombreArchivo="hallazgos_pendientes"
          size="small"
          emptyMessage="No hay hallazgos pendientes"
          onRowClick={(e) => {
            navigate(`/proceso/${e.data.actividad.proceso.id}/actividades/${e.data.actividadId}`);
          }}
          rowClassName={() => "cursor-pointer"}
        >
          <Column field="_clienteText" header="Cliente" />
          <Column field="_procesoText" header="Proceso" />
          <Column field="_tipoHallazgo" header="Tipo de hallazgo" />
          <Column field="_colaboradorText" header="Colaborador" />
          <Column
            header="Días"
            field="_dias"
            sortable
            body={diasBody}
            style={{ width: "8em" }}
          />
        </TablaFiltrable>
      </AccordionTab>
    </Accordion>
  );
}
